import { render, staticRenderFns } from "./SourceSelector.vue?vue&type=template&id=53de201a&"
import script from "./SourceSelector.vue?vue&type=script&lang=js&"
export * from "./SourceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports